import { FixaAccordionItem } from "../../../wrappers/FixaAccordion/FixaAccordion";
import { FixaListViewItem } from "../../../wrappers/FixaListView/FixaListViewItem";
import {
  SelectGroup,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import { symmetricDifference } from "../../utils/filter/filtervalue";
import {
  getSelectOptionKey,
  isEmptySelectOptionStringArray,
  isSelectOption,
  isSelectOptionSelected,
} from "../../utils/filter/selectoption";
import { localeIncludes } from "./SelectListView.helper";
import FilterAccordionCss from "../FilterAccordion/FilterAccordion.module.css";
import { FixaListView } from "../../../wrappers/FixaListView/FixaListView";

interface GroupMultiSelectListItemProps {
  item: SelectGroup;
  prefix: string;
  selected: StringArrayFilterValue;
  searchInput: string;
  onChange: (option: SelectOption, isSelected: boolean) => void;
  defaultValue: StringArrayFilterValue;
}

export const GroupMultiSelectListItem = ({
  item,
  prefix,
  selected,
  searchInput,
  onChange,
  defaultValue,
}: GroupMultiSelectListItemProps) => {
  const { options, title } = item;
  const groupOptionValues = options.map(({ value }) => value);
  const groupDefaultFilterValue = defaultValue.value.filter((value) =>
    groupOptionValues.includes(value)
  );
  const groupSelectedFilterValue = selected.value.filter((value) =>
    groupOptionValues.includes(value)
  );
  const filterValueCount = symmetricDifference(
    groupSelectedFilterValue,
    groupDefaultFilterValue
  ).length;
  const filteredOptions = options.filter(
    (option) =>
      !isSelectOption(option) ||
      isSelectOptionSelected(selected, option) ||
      localeIncludes(option.title, searchInput)
  );

  if (!filteredOptions.length) {
    return null;
  } else {
    const optionKey = getSelectOptionKey("multiselectgroup", item);
    return (
      <FixaAccordionItem
        id={`filter-option-accordion-${optionKey}`}
        data-testid={`filter-accordion-${optionKey}`}
        title={filterValueCount ? `${title} (${filterValueCount})` : title}
        className={FilterAccordionCss["accordion-item-title"] ?? ""}
        open={true}
      >
        <FixaListView
          id={`listview-option-accordion-${prefix}-${optionKey}}`}
          data-testid={`listview-option-accordion-${prefix}-${optionKey}}`}
          size="small"
          showDivider={false}
        >
          {filteredOptions.map((option, idx) => {
            const { value } = option;
            const isSelected = isSelectOptionSelected(selected, option);
            const isClearAllOption = isEmptySelectOptionStringArray(option);
            return (
              <FixaListViewItem
                key={getSelectOptionKey(idx, option)}
                inset
                onChange={() => {
                  onChange(option, isSelected);
                }}
                control={isClearAllOption ? "radiobutton" : "checkbox"}
                controlProps={{
                  value: isSelected ? "ON" : "OFF",
                  checked: isSelected,
                }}
                showDivider={false}
                title={option.title}
                data-testid={`listview-option-${prefix}-${value}`}
              />
            );
          })}
        </FixaListView>
      </FixaAccordionItem>
    );
  }
};
